import { Folder } from '@api/types';
import { FolderNode } from '@shared/layout/sidebar-menu/folder-menu/folder-menu.datasource';
import { SupportedMimeTypes } from '@shared/utils/file-type';

export interface ImportDocument {
  type: SupportedMimeTypes;
  file: File;
}
export interface FileTreeNode {
  id: string;
  title: string;
  children: FileTreeNode[];
  parent: FileTreeNode;
  file: File;
  isValid: boolean;
}

export class TreeNode implements FileTreeNode {
  constructor(
    public id: string,
    public title: string,
    public children: TreeNode[],
    public parent: TreeNode,
    public file: File,
    public isValid: boolean
  ) {}
}

export enum ImportType {
  'Folder' = 'folder',
  File = 'file'
}

export class ImportJob {
  public rootFolder: Folder;
  public isImporting = false;
  public isFinished = false;
  public fileImported = 0;
  public fileImportingQueue: TreeNode[] = [];
  public redirectUrl: string = null;
  public isFailed = false;

  constructor(
    public root: TreeNode,
    public folderName: string,
    public totalFiles: number,
    public fileName?: string,
    public file?: ImportDocument,
    public selectedFolderId?: string
  ) {}
}

export interface BatchImportJob {
  jobs: ImportJob[];
  type: ImportType;
}

export class DragImportObject {
  files: File[];
  selectedFolder: FolderNode;
  fullPath?: string[];
  type: ImportType;

  constructor(type: ImportType, files: File[], selectedFolder: FolderNode, fullPath?: string[]) {
    this.type = type;
    this.files = files;
    this.selectedFolder = selectedFolder;
    this.fullPath = fullPath;
  }
}
